export default __webpack_public_path__ + "static/media/445.d422c4f4.gif";